import { render } from "./SegmentationBlockOR.vue?vue&type=template&id=42fa5893&scoped=true"
import script from "./SegmentationBlockOR.vue?vue&type=script&lang=ts"
export * from "./SegmentationBlockOR.vue?vue&type=script&lang=ts"

import "./SegmentationBlockOR.vue?vue&type=style&index=0&id=42fa5893&scoped=true&lang=scss"
import "./SegmentationBlockOR.vue?vue&type=style&index=1&id=42fa5893&lang=scss"
script.render = render
script.__scopeId = "data-v-42fa5893"

export default script